import Vue from 'vue';
import Vuex from 'vuex';
import Router from 'vue-router';

import * as VueGoogleMaps from 'vue2-google-maps';
import 'default-passive-events'

import simplebar from 'simplebar-vue';
import 'simplebar/dist/simplebar.min.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserSecret } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueCurrencyInput from 'vue-currency-input'

import 'shared-icons';

import '@shared/plugins/element';
import { i18n } from '@shared/i18n';

import {
  setupComponentsFiltersDirectivesAndMixins,
  storeAsync,
  routerAsync,
} from '@/app-module';
import app from '@/app.vue';

import { SettingsService } from '@modules/settings/settings-service';

document.title = i18n('app.title');
SettingsService.applyTheme('default');

Vue.config.productionTip = process.env.NODE_ENV === 'production';

Vue.use(Router);
Vue.use(Vuex);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBnF10ORfovm2WLYQjnxp9hycIjXMRpX48',
    libraries: 'places',
  },
});
Vue.use(VueCurrencyInput, {})

setupComponentsFiltersDirectivesAndMixins();

library.add(faUserSecret);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('simplebar', simplebar);

// eslint-disabled-next-line
new Vue({
  store: storeAsync(),
  router: routerAsync(),
  render: (h) => h(app),
}).$mount('#app');
